import axios from 'axios';
import {base_api} from './base';

export function putEventToProductionMode(eventId, isWithDataDeletion) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/Events?eventId=${eventId}&isWithDataDeletion=${isWithDataDeletion}`, {}, {headers});
}

export function getEvents(includeDeleted) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Events?includeDeleted=${includeDeleted}`, {headers});
}

export function getEventById(id) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Events/GetById?id=${id}`, {headers});
}

export function getEventByName(name) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Events/GetByName?name=${name}`, {headers});
}

export function addEvent(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Events/AddEvent`, data, {headers});
}

export function updateEvent(eventId, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/Events/UpdateEvent?eventId=${eventId}`, data, {headers});
}

export function deleteEvent(eventId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/Events/DeleteEvent?eventId=${eventId}`, {headers});
}

//----------------------------------------

export function getCreationMode(eventId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Events/GetCreationMode?eventId=${eventId}`, {headers});
}

export function addCreationMode(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Events/InsertCreationMode`, data, {headers});
}

export function updateCreationMode(eventId, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/Events/UpdateCreationMode?eventId=${eventId}`, data, {headers});
}

export function deleteCreationMode(id) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/Events/DeleteCreationMode?id=${id}`, {headers});
}

//---------------------------------------- Dashboard

export function getDashboard(eventId, companyId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Events/GetDashboard?eventId=${eventId}&companyId=${companyId}`, {headers});
}

export function addDashboard(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Events/InsertDashboard`, data, {headers});
}

export function updateDashboard(eventId, companyId, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/Events/UpdateDashboard?eventId=${eventId}&companyId=${companyId}`, data, {headers});
}

export function deleteDashboard(id) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/Events/DeleteDashboard?id=${id}`, {headers});
}

//---------------------------------------- EmailConfig

export function getEmailConfig(eventId, companyId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Events/GetEmailConfig?eventId=${eventId}&companyId=${companyId}`, {headers});
}

export function addEmailConfig(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Events/InsertEmailConfig`, data, {headers});
}

export function updateEmailConfig(eventId, companyId, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/Events/UpdateEmailConfig?eventId=${eventId}&companyId=${companyId}`, data, {headers});
}

export function deleteEmailConfig(id) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.delete(`${base_api}/Events/DeleteEmailConfig?id=${id}`, {headers});
}

//----------------------------------------

export function uploadImages(eventId, file) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Events/UploadImages?eventId=${eventId}`, file, {headers});
}



// WEBPACK FOOTER //
// ./src/services/Events.service.js